module.exports = __webpack_public_path__ + "media/background-voice.8ea80d86.mp3";